import ctl from "@netlify/classnames-template-literals";

export const tabListWrapper = ctl(`
  mb-8 
  after:mt-[-2px] 
  after:block 
  after:border-b-2
  after:border-neutral-200
  z-10
`);

export const tabListWrapperDark = ctl(`
  mb-8 
  after:mt-[-2px] 
  after:block 
  after:border-b-2
  after:border-white/20
  z-10
`);

export const tabListWrapperGreen = ctl(`
  mb-8 
  after:mt-[-2px] 
  after:block 
  after:border-b-1
  after:border-neutral-700
  z-10
`);

export const tabWrapper = ctl(`
  mr-4
  md:mr-8
  last:mr-0
  flex
`);
